module.exports = {
  NODE_ENV: '"production"',
  DS_URL: '"hf-gtvan-web03:6020"',
  // Production - Microsoft Auth
  VUE_APP_SIGNALR_HUB_URL: '"https://www.envirodata.hatfieldgroup.com/signalr"',
  VUE_APP_MS_CLIENT_ID: '"b9fbe93d-8aea-426c-9a2c-d635ccb1e740"',
  VUE_APP_MS_REDIRECT_URI: '"https://www.envirodata.hatfieldgroup.com/Office365AuthResponse/"',
  VUE_APP_MS_AUTHORITY: '"https://login.microsoftonline.com/e0b2a496-c186-4e92-b4b0-7d466b05d8d9"',
}
